import { AppHeader } from "@/components/diplomate/AppHeader";
import { HeroSection } from "@/components/diplomate/HeroSection";
import { TopModeSwitcher } from "@/components/diplomate/TopModeSwitcher";
import { ModeSwitcher } from "@/components/diplomate/ModeSwitcher";
import { ToneSelector } from "@/components/diplomate/ToneSelector";
import { DiplomacySlider } from "@/components/diplomate/DiplomacySlider";
import { ReverseIntensityChips } from "@/components/diplomate/ReverseIntensityChips";
import { InputPanel } from "@/components/diplomate/InputPanel";
import { OutputPanel } from "@/components/diplomate/OutputPanel";
import { AntidoteResultPanel } from "@/components/diplomate/AntidoteResultPanel";
import { BullshitScoreResultPanel } from "@/components/diplomate/BullshitScoreResultPanel";
import { AppFooter } from "@/components/diplomate/AppFooter";
import { PrivacyBanner } from "@/components/diplomate/PrivacyBanner";
import { useCordialement } from "@/hooks/useCordialement";
import { TRANSLATIONS } from "@/i18n";

export default function Home() {
  const c = useCordialement();
  const t = TRANSLATIONS[c.lang];

  return (
    <div className="min-h-screen relative" data-testid="home-page">
      <PrivacyBanner lang={c.lang} />
      <AppHeader
        lang={c.lang}
        onToggleLang={c.toggleLang}
        history={c.history}
        onClearHistory={c.clearHistory}
        onSelectHistory={c.loadFromHistory}
        quota={c.quota}
      />
      <HeroSection lang={c.lang} />

      <section className="relative z-10 max-w-7xl mx-auto px-4 sm:px-8 pb-16">
        <div className="rule-editorial mb-10 sm:mb-12 opacity-60" aria-hidden />

        {/* 4-mode navigation — always visible */}
        <TopModeSwitcher lang={c.lang} topMode={c.topMode} onChange={c.setTopMode} />

        {/* CORDIALEMENT-specific controls */}
        {c.topMode === "cordialement" && (
          <>
            <ModeSwitcher lang={c.lang} mode={c.mode} onChange={c.setMode} />
            <ToneSelector lang={c.lang} tone={c.tone} onChange={c.setTone} />
            <DiplomacySlider
              lang={c.lang}
              value={c.diplomacy}
              onChange={c.setDiplomacy}
            />
          </>
        )}

        {/* REVERSE-specific controls */}
        {c.topMode === "reverse" && (
          <ReverseIntensityChips
            lang={c.lang}
            value={c.reverseIntensity}
            onChange={c.setReverseIntensity}
          />
        )}

        {/* Section 03 label — Rédaction */}
        <div className="flex items-center gap-3 mb-4">
          <span className="dossier-tag font-bold">{t.sectionInputLabel}</span>
          <span className="flex-1 h-px bg-black/15" />
        </div>

        <div className="grid lg:grid-cols-2 gap-5">
          <InputPanel
            lang={c.lang}
            topMode={c.topMode}
            mode={c.mode}
            text={c.text}
            onChange={c.setText}
            onGenerate={c.generate}
            loading={c.loading}
          />

          {(c.topMode === "cordialement" || c.topMode === "reverse") && (
            <OutputPanel
              ref={c.outputRef}
              lang={c.lang}
              topMode={c.topMode}
              tone={c.tone}
              output={c.output}
              loading={c.loading}
              copied={c.copied}
              onCopy={c.copy}
              onRegenerate={c.generate}
            />
          )}

          {c.topMode === "antidote" && (
            <AntidoteResultPanel
              ref={c.outputRef}
              lang={c.lang}
              result={c.antidoteResult}
              loading={c.loading}
              copied={c.copied}
              onCopy={c.copy}
              onRegenerate={c.generate}
            />
          )}

          {c.topMode === "bullshit" && (
            <BullshitScoreResultPanel
              ref={c.outputRef}
              lang={c.lang}
              result={c.bullshitResult}
              loading={c.loading}
              copied={c.copied}
              onCopy={c.copy}
              onRegenerate={c.generate}
            />
          )}
        </div>
      </section>

      <AppFooter lang={c.lang} />
    </div>
  );
}
